import { Table } from 'react-bootstrap';
import React from 'react';
import { ApiWebhookRequest, ApiWebhookRequestStatus } from '../../api';
import FormattedDateTime from '../../common/datetime/FormattedDateTime';
import { SalvButton, SalvModal } from '@salvapp/ui-components';

export interface WebhookRequestModalProps {
  show: boolean;
  onComplete: () => void;
  scheduleRetry?: (webhookRequestId: number | undefined) => void;
  request: ApiWebhookRequest | null;
  isTestRequest?: boolean;
}

export const WebhookRequestModal = ({
  request,
  show,
  onComplete,
  scheduleRetry,
  isTestRequest = false,
}: WebhookRequestModalProps) => {
  const webhookRequest = request || ({} as ApiWebhookRequest);
  return (
    <SalvModal show={show} onHide={() => onComplete()}>
      <SalvModal.Header closeButton>
        {isTestRequest ? 'Webhook endpoint test' : `Webhook request #${webhookRequest.id}`}
      </SalvModal.Header>

      <SalvModal.Body>
        <Table striped hover size='sm' className='card-table'>
          <tbody>
            <tr>
              <th>Trigger</th>
              <td>{webhookRequest.trigger}</td>
            </tr>
            <tr>
              <th>URL</th>
              <td className='text-break'>{webhookRequest.url}</td>
            </tr>
            {webhookRequest.token !== null && (
              <tr>
                <th>Token</th>
                <td className='text-break'>{webhookRequest.token}</td>
              </tr>
            )}
            <tr>
              <th>Status</th>
              <td
                className={
                  webhookRequest.status === ApiWebhookRequestStatus.FAILED
                    ? 'text-danger'
                    : webhookRequest.status === ApiWebhookRequestStatus.COMPLETED
                      ? 'text-success'
                      : ''
                }
              >
                {isTestRequest && webhookRequest.status === ApiWebhookRequestStatus.NEW
                  ? 'Test pending...'
                  : webhookRequest.status}
              </td>
            </tr>
            {webhookRequest.retryId != null && (
              <tr>
                <th>Retry ID:</th>
                <td>{webhookRequest.retryId}</td>
              </tr>
            )}
            {webhookRequest.executionDuration != null && (
              <tr>
                <th>Duration</th>
                <td>{webhookRequest.executionDuration} ms</td>
              </tr>
            )}
            <tr>
              <th>Request</th>
              <td className='text-break'>{webhookRequest.requestContent}</td>
            </tr>
            {webhookRequest.responseContent && (
              <tr>
                <th>Response</th>
                <td className='text-break'>{webhookRequest.responseContent}</td>
              </tr>
            )}
            {(webhookRequest.responseStatus || isTestRequest) && (
              <tr>
                <th>Response status</th>
                <td>{webhookRequest.responseStatus}</td>
              </tr>
            )}
            <tr>
              <th>Created time</th>
              <td>
                <FormattedDateTime date={webhookRequest.createdTime} showTime />
              </td>
            </tr>
            {webhookRequest.retryTime && (
              <tr>
                <th>Retry time</th>
                <td>
                  <FormattedDateTime date={webhookRequest.retryTime} showTime />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </SalvModal.Body>
      <SalvModal.Footer>
        {scheduleRetry && !webhookRequest.retryId && webhookRequest.status === 'FAILED' && (
          <SalvButton variant='primary' onClick={() => scheduleRetry(webhookRequest.id)} label='Retry' />
        )}
        {scheduleRetry && !webhookRequest.retryId && webhookRequest.status === 'SCHEDULED_RETRY' && (
          <SalvButton variant='primary' onClick={() => scheduleRetry(webhookRequest.id)} label='Retry now' />
        )}
        <SalvButton variant='muted' onClick={() => onComplete()} label='Close' />
      </SalvModal.Footer>
    </SalvModal>
  );
};
